import React from "react";
import Top from "../../src/assets/top-2.png";
import "../style/top.css";

const TopImage = () => {
  return (
    <div className="top-container">
      {/* top image: Logo */}
      <img src={Top} alt="image" className="top-first" />
    </div>
  );
};

export default TopImage;
